import { HttpController } from '@/communication'
import Loading from 'quasar/src/plugins/loading/Loading.js';
let axiosInstance = {};

const httpPlugin = {
  install(app) {
    app.config.globalProperties.$http = new HttpController()
    axiosInstance = app.config.globalProperties.$http;

    app.config.globalProperties.$http.enableInterceptors = this.enableInterceptors;
    app.config.globalProperties.$http.disableInterceptors = this.disableInterceptors;
    this.enableInterceptors();
  },

  _setupResponseInterceptor() {
    this.responseInterceptor = axiosInstance.interceptors.response.use(
      function(response) {
        Loading.hide();
        return response;
      },
      function(error) {
        Loading.hide();
        return Promise.reject(error);
      }
    );
  },
  _setupRequestInterceptor() {
    this.requestInterceptor = axiosInstance.interceptors.request.use(
      (config) => {
        Loading.show(); 
        return config;
      },
      (error) => {
        Loading.hide();
        return Promise.reject(error);
      }
    );
  },
  enableInterceptors() {
    httpPlugin._setupResponseInterceptor();
    httpPlugin._setupRequestInterceptor();
  },
  disableInterceptors() {
    axiosInstance.interceptors.request.eject(httpPlugin.requestInterceptor);
    axiosInstance.interceptors.response.eject(httpPlugin.responseInterceptor);
  }
}

export default httpPlugin
